import {
  useMutation,
  UseMutationOptions,
  UseMutationResult,
  useQuery,
  UseQueryOptions,
  UseQueryResult,
  useQueryClient,
} from "@tanstack/react-query";
import { API_ENDPOINTS } from "../../../constants/api_endpoints";
import { TResponse } from "../../../types/common";
import { IPageDetailPayload } from "@src/types/api/page";
import { pageDetail, savePage } from "./callback";

export const  usePageSave = (
  {
    onSuccess,
    onError,
  }: {
    onSuccess?: (res: TResponse<IPageDetailPayload>) => void;
    onError?: (error: unknown) => void;
  },
  options: UseMutationOptions<
    TResponse<IPageDetailPayload>,
    unknown,
    IPageDetailPayload
  > = {}
): UseMutationResult<TResponse<IPageDetailPayload>, unknown, IPageDetailPayload> => {
  const queryClient = useQueryClient();

  return useMutation<TResponse<IPageDetailPayload>, unknown, IPageDetailPayload>({
    mutationFn: async (data: IPageDetailPayload) => {
      const response = await savePage(data);
      return response.data;
    },
    onSuccess: (res, ...rest) => {
      if (res.data) {
        queryClient.invalidateQueries({
          queryKey: [API_ENDPOINTS.PAGE_DETAIL],
        });
      }

      onSuccess?.(res);
      options?.onSuccess?.(res, ...rest);
    },
    onError: (error, ...rest) => {
      onError?.(error);
      options?.onError?.(error, ...rest);
    },
    ...options,
  });
};

export const usePageDetail = (
    type: string
): UseQueryResult<TResponse<IPageDetailPayload>, Error> => {
  return useQuery<TResponse<IPageDetailPayload>, Error>({
    queryKey: [API_ENDPOINTS.HOMEPAGE_DETAIL, type],
    queryFn: async () => {
      const res = await pageDetail(type);
      return res.data;
    },
    refetchOnWindowFocus: false,
    staleTime: 300000,
  });
};
